export default {
    topics: [
        {
            title: ' Deploy ',
            href: 'sm-offerSpace-Deploy.html',
            attributes: { 'data-id': 'sm-offerSpace-Deploy' },
            menu: { hasChildren: false },
            tocID: 'sm-offerSpace-Deploy-d66e3349',
            topics: [],
        },
        {
            title: ' GetGeneratedCode ',
            href: 'sm-offerSpace-GetGeneratedCode.html',
            attributes: { 'data-id': 'sm-offerSpace-GetGeneratedCode' },
            menu: { hasChildren: false },
            tocID: 'sm-offerSpace-GetGeneratedCode-d66e3357',
            topics: [],
        },
        {
            title: ' GetUrls ',
            href: 'sm-offerSpace-GetUrls.html',
            attributes: { 'data-id': 'sm-offerSpace-GetUrls' },
            menu: { hasChildren: false },
            tocID: 'sm-offerSpace-GetUrls-d66e3365',
            topics: [],
        },
        {
            title: ' Publish ',
            href: 'sm-offerSpace-Publish.html',
            attributes: { 'data-id': 'sm-offerSpace-Publish' },
            menu: { hasChildren: false },
            tocID: 'sm-offerSpace-Publish-d66e3373',
            topics: [],
        },
    ],
};

